import { updatePropertyFn } from "@repo/dynamicEditor/src/helpers/updatePropertiesHooks";

export function segmentCascade<TData>(updateCallback: updatePropertyFn<TData>, parentPropName: string) {
	return async function cascadeSegment(id: string, value: any, newState: TData) {
		async function update(name: string, value: any) {
			newState = await updateCallback(name, value, newState);
		}
		const clear = (name: string) => update(name, null);
		const clearOnParent = (name: string) => clear(`${parentPropName}.${name}`);
		//Custom logic
		switch (id) {
			case `${parentPropName}.brandId`:
				await clearOnParent(`marketerId`);
				await clearOnParent(`marketerName`);
				break;
			case `${parentPropName}.marketerId`:
				await clearOnParent(`stateId`);
				await clearOnParent(`stateName`);
				break;
		}
		return newState;
	};
}

export function companySegmentCascade<TData>(updateCallback: updatePropertyFn<TData>, parentPropName: string) {
	return async function cascadeCompanySegment(id: string, value: any, newState: TData) {
		async function update(name: string, value: any) {
			newState = await updateCallback(name, value, newState);
		}
		const clear = (name: string) => update(name, null);
		const clearOnParent = (name: string) => clear(`${parentPropName}.${name}`);
		//Custom logic
		switch (id) {
			case `${parentPropName}.companyId`:
				await clearOnParent(`divisionId`);
				await clearOnParent(`regionId`);
				await clearOnParent(`marketId`);
				break;
			case `${parentPropName}.divisionId`:
				await clearOnParent(`regionId`);
				await clearOnParent(`marketId`);
				break;
			case `${parentPropName}.regionId`:
				await clearOnParent(`marketId`);
				break;
		}
		return newState;
	};
}
